export default __webpack_public_path__ + "static/media/mus-driverslicense.efda670b.mp4";